import * as React from 'react';
import { FC } from 'react';

import { HStack, Text, VStack } from '@rbilabs/universal-components';
import { capitalize } from 'lodash-es';

import Currency from 'components/currency';
import { usePrevious } from 'hooks/use-previous';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants';
import { getItemLoyaltyRewardDiscount } from 'utils/cart/helper';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { IPrice } from '../types';

const commonTextConfig = {
  fontWeight: 'bold',
  fontSize: 'sm',
  lineHeight: 'sm',
  margin: 0,
  color: primitive.$bbqBrown,
};

const RewardsFreeText = Text.withConfig({
  ...commonTextConfig,
});

const PriceFree = () => {
  const rewardsFreeText = capitalize(t('free'));
  return (
    <HStack alignItems="center" focusable accessibilityLabel={rewardsFreeText}>
      <RewardsFreeText>{rewardsFreeText}</RewardsFreeText>
    </HStack>
  );
};

export const Price: FC<React.PropsWithChildren<IPrice>> = ({ item, isOffer, rewardApplied }) => {
  const price = priceForCartEntry(item);

  const { formatCurrencyForLocale } = useUIContext();
  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);
  const isRewardApplied = Boolean(rewardApplied && !isOffer);
  const discountPrice =
    price - getItemLoyaltyRewardDiscount({ cartEntry: item, appliedLoyaltyRewards });
  const prevDiscountPrice = usePrevious(discountPrice);
  const discountDisplay = rewardApplied ? discountPrice : prevDiscountPrice;

  const beforeDiscountPriceLabel = `${formatCurrencyForLocale(price)} ${
    rewardApplied ? t('beforeDiscount') : ''
  }`;

  const afterDiscountLabel = `${discountDisplay} ${t('afterDiscount')}`;

  return (
    <VStack alignItems="flex-end" marginLeft="$2">
      {rewardApplied && discountPrice === 0 ? (
        <PriceFree />
      ) : (
        <Currency
          amount={isRewardApplied ? discountDisplay : price}
          textProps={{
            accessibilityLabel: discountDisplay ? afterDiscountLabel : beforeDiscountPriceLabel,
          }}
          isBold
        />
      )}
    </VStack>
  );
};
